module.exports = __webpack_public_path__ + "img/data-quality-music-publishers-level 1.78b8ad87.svg";